export type NewsletterAgreementValues = (typeof newsletterAgreementValues)[number];
export type PhoneContactAgreementValues = (typeof phoneContactAgreementValues)[number];

// PTS-287: formularze tylko udzielają zgody — "disabled" w SR.event.sendFormData natychmiast wycofuje
// zgodę daną wcześniej na ten profil, więc nie jest dozwoloną wartością.
export const newsletterAgreementValues = ["enabled"] as const;
export const phoneContactAgreementValues = ["enabled"] as const;

// Odznaczony checkbox znaczy „tym razem nie wyrażam zgody”, a nie „cofam zgodę”: zwracamy undefined,
// a `formTypeFactory` pomija takie pole, więc nie trafia ono do payloadu Synerise.
export const grantedAgreement = (accepted?: boolean) => (accepted ? ("enabled" as const) : undefined);
